// @vendors
const { isEmpty } = require('lodash');
const { formatText } = require('core/i18n').i18n;

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { CHECK_LEGALES_ENABLED } = require('constants/flagBasedFeatures');
const {
    CHECKING_ACCOUNT_PRODUCT_ALIAS,
    OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
} = require('constants/hiringProductInformation');

const reset = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_WINDOW_RESET,
});

const termsAndCondsLegalWindowRequest = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_WINDOW_REQUEST,
});

const termsAndCondsLegalWindowSuccess = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_WINDOW_SUCCESS,
});

const termsAndCondsLegalWindowFailure = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_WINDOW_FAILURE,
});

// ACCEPT BY DOCUMENT
const termsAndCondsLegalAcceptDocumentReset = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_ACCEPT_DOCUMENT_RESET,
});

const termsAndCondsLegalAcceptDocumentRequest = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_ACCEPT_DOCUMENT_REQUEST,
});

const termsAndCondsLegalAcceptDocumentSuccess = (dmsDocumentId) => {
    return {
        type: actionTypes.TERMS_AND_CONDS_LEGAL_ACCEPT_DOCUMENT_SUCCESS,
        payload: {
            dmsDocumentId
        }
    }
}

const termsAndCondsLegalAcceptDocumentFailure = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_ACCEPT_DOCUMENT_FAILURE,
});

// ACCPET FINAL TERMS
const termsAndCondsLegalDICRequest = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_DIC_REQUEST,
});

const termsAndCondsLegalDICSuccess = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_DIC_SUCCESS
});

const termsAndCondsLegalDICFailure = () => ({
    type: actionTypes.TERMS_AND_CONDS_LEGAL_DIC_FAILURE,
});

const termsAndCondsLegalWindowSetParams = (precontractualAccountAlias = '', contractualAccountAlias = '') => {
    return {
        type: actionTypes.TERMS_AND_CONDS_LEGAL_WINDOW_SET_PARAMS,
        payload: {
            precontractualAccountAlias: precontractualAccountAlias,
            contractualAccountAlias: contractualAccountAlias,
        }
    };
}

const setTermsAndCondsLegalWindow = () => (dispatch, getState) => {
    const termsAndCondsCountryFlags = getState().flagBasedFeatures.get(CHECK_LEGALES_ENABLED);
    const immContracts = getState().contracts;
    const immTermsAndConds = getState().termsAndCondsLegalWindow;
    const contractType = immTermsAndConds.get('precontractualAccountAlias');
    const contractName = immContracts.get('name_contract');
    const operationProcessId = getState().preContractualPolling.get('operationProcessId');
    let contractHiringData = {};

    if (contractName === 'checking-account') { //Adding properties for passport logic
        contractHiringData['passportProductId'] = CHECKING_ACCOUNT_PRODUCT_ALIAS;
    } else {
        contractHiringData = immContracts.get('hiring_data_contract').toJS();
    }

    let cardImage = findElementbyId(immContracts.get('card_details'), 'card_image');
    let products = [contractHiringData];

    if (!!cardImage) {
        products.push(
            {
                passportProductId: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS, //Checking and payroll hiring always links a debit card
            }
        );
    }

    const labelRaw = __CONTACT_CENTER__ ? immContracts.getIn(['confirmationCheckboxes', 'list', '0', 'labels']) : immContracts.get('precontractualConfirmationLabel');
    let label;
    if (!!labelRaw) { 
        labelRaw.forEach(item => {
            if (!!label) {
                label = `${label}${formatText(item.get('text'))}`;
            } else {
                label = formatText(item.get('text'));
            }
        });
    }
    

    if (termsAndCondsCountryFlags && !!operationProcessId && !!label && !!contractType && !isEmpty(products)) {
        dispatch(termsAndCondsLegalWindowRequest());

        const requestData = {
            query: {
                productName: contractType,
                operationProcessId,
                productsHired: products,
                textChecked : label,
            },
        };
    
        return APIPost({
                dispatch,
                endpoint: 'termsAndConds',
                params: requestData,
            })
            .then(() => dispatch(termsAndCondsLegalWindowSuccess()))
            .catch(() => dispatch(termsAndCondsLegalWindowFailure()));
    }
};

const setTermsAndCondsDic = (productId) => (dispatch, getState) => {
    const termsAndCondsCountryFlags = getState().flagBasedFeatures.get(CHECK_LEGALES_ENABLED);
    const operationProcessId = getState().preContractualPolling.get('operationProcessId');
    const immAllDocuments = getState().preContractualPolling.getIn(['documents', 'allDocuments']);
    const immContracts = getState().contracts;

    const labelRaw = __CONTACT_CENTER__ ? immContracts.getIn(['confirmationCheckboxes', 'list', '0', 'labels']) : immContracts.get('precontractualConfirmationLabel');
    let label;
    if (!!labelRaw) { 
        labelRaw.forEach(item => {
            if (!!label) {
                label = `${label}${formatText(item.get('text'))}`;
            } else {
                label = formatText(item.get('text'));
            }
        });
    }

    if (termsAndCondsCountryFlags && !!operationProcessId && !!labelRaw) {
        dispatch(termsAndCondsLegalDICRequest());

        const allDocuments = immAllDocuments.toJS().map(document => ({
            documentType: document.documentType,
            documentId: document.dmsDocumentId,
            documentChecksum: document.checksum,
        }))

        const requestData = {
            query: {
                productId,
                acceptedText: label,
                scrollDown: true,
                urlVersion: 1,
                documents: allDocuments,
                operationProcessId
            }
        };

        return APIPost({
                dispatch,
                endpoint: 'termsAndCondsAcceptDocuments',
                params: requestData,
            })
            .then(() => {
                dispatch(termsAndCondsLegalDICSuccess())
                dispatch(termsAndCondsLegalAcceptDocumentReset())
            })
            .catch(() => dispatch(termsAndCondsLegalDICFailure()));
    }
};

const setAcceptDocument = ({ documentId, documentChecksum, documentType, productId }) => (dispatch, getState) => {
    const termsAndCondsCountryFlags = getState().flagBasedFeatures.get(CHECK_LEGALES_ENABLED);
    const operationProcessId = getState().preContractualPolling.get('operationProcessId');

    if (termsAndCondsCountryFlags && !!operationProcessId) {
        dispatch(termsAndCondsLegalAcceptDocumentRequest());

        const requestData = {
            header: {
                version: 'v2',
            },
            query: {
                documentId,
                scrollDown: true,
                documentChecksum,
                documentType,
                productId,
                operationProcessId
            }
        };

        return APIPost({
                dispatch,
                endpoint: 'documentAccept',
                params: requestData,
            })
            .then(() => {
                dispatch(termsAndCondsLegalAcceptDocumentSuccess(documentId))
            })
            .catch(() => dispatch(termsAndCondsLegalAcceptDocumentFailure()));
    } else {
        dispatch(termsAndCondsLegalDICFailure())
    }
};

module.exports = {
    reset,
    setTermsAndCondsLegalWindow,
    termsAndCondsLegalWindowSetParams,
    setTermsAndCondsDic,
    setAcceptDocument
};
